import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ListItemIcon, IconButton, Menu, MenuItem, Divider, Box } from "@mui/material";
import {
  Folder as FolderIcon,
  AdminPanelSettings as AdminIcon,
  Group as GroupIcon,
  Menu as MenuIcon,
  Logout,
} from "@mui/icons-material";
import VersionBadge from "../../ui/VersionBadge";
import { useRole } from "../../../contexts/RoleContext";

function MenuButton({ handleSignOut }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin, isSharedUser, tenant } = useRole();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOutMethod = () => {
    handleMenuClose();
    handleSignOut();
  };

  return (
    <>
      <IconButton edge="start" aria-label="menu" onClick={handleMenuClick}>
        <MenuIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            navigate(`/${tenant}`);
            handleMenuClose();
          }}
          selected={
            !location.pathname.includes("/admin") &&
            !location.pathname.includes("/shared")
          }
        >
          <ListItemIcon>
            <FolderIcon fontSize="small" />
          </ListItemIcon>
          My Drive
        </MenuItem>
        {/* Opções baseadas em roles */}
        {isAdmin() && (
          <>
            <MenuItem
              onClick={() => {
                navigate(`/${tenant}/shared`);
                handleMenuClose();
              }}
              selected={location.pathname.includes("/shared")}
            >
              <ListItemIcon>
                <GroupIcon fontSize="small" />
              </ListItemIcon>
              Compartilhados
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate(`/${tenant}/admin`);
                handleMenuClose();
              }}
              selected={location.pathname.includes("/admin")}
            >
              <ListItemIcon>
                <AdminIcon fontSize="small" />
              </ListItemIcon>
              Administração
            </MenuItem>
          </>
        )}
        {isSharedUser() && (
          <MenuItem
            onClick={() => {
              navigate(`/${tenant}/shared`);
              handleMenuClose();
            }}
            selected={location.pathname.includes("/shared")}
          >
            <ListItemIcon>
              <GroupIcon fontSize="small" />
            </ListItemIcon>
            Compartilhados
          </MenuItem>
        )}

        <MenuItem onClick={handleSignOutMethod}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>

        <Divider sx={{ my: 0.5 }} />

        <Box sx={{ px: 2, py: 0.8, textAlign: "center" }}>
          <VersionBadge variant="text" />
        </Box>
      </Menu>
    </>
  );
}

export default MenuButton;
